import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { catchError, switchMap } from 'rxjs/operators';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private msalService: MsalService, private router: Router, public toastr: ToastrService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const account = this.msalService.instance.getActiveAccount();
    const userType = localStorage.getItem('UserType');
    const userName = localStorage.getItem('username');
    const authToken = localStorage.getItem('token');
    const accesstoken = localStorage.getItem('accesstoken');

    //if (userType == 'D') {
      if (authToken) {
        const modifiedReq = req.clone({
          setHeaders: {
           // 'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`
          }
        });
        return next.handle(modifiedReq);
      }
    //}
    if (accesstoken) {
      if (!account) {
        return next.handle(req);
      }

      return from(
        this.msalService.instance.acquireTokenSilent({
          scopes: ['api://56cf13d1-1751-41ed-bf64-59880703bd16/access_as_user'],
          account
        })
      ).pipe(
        switchMap((result) => {
          const cloned = req.clone({
            setHeaders: {
              Authorization: `Bearer ${result.accessToken}`,
              'X-User-Email': userName
            }
          });
          return next.handle(cloned);
        }),
        catchError((error) => {
          if (error instanceof InteractionRequiredAuthError || error.status === 401) {
            this.toastr.error('You are unauthorized');
            localStorage.clear();
            this.router.navigate(['/pages/login']);
          }
          if (error.status === 400) {
            return throwError(error);
          }

          return throwError(() => error);
        })
      );
    }
    return next.handle(req);
  }

}
